export const getViewKey = (view, id) => {
  return view + '-' + id
};


// WEBPACK FOOTER //
// ./src/Utils.js